import { render, staticRenderFns } from "./SalesByStoreTable.vue?vue&type=template&id=2436ce66&"
import script from "./SalesByStoreTable.vue?vue&type=script&lang=js&"
export * from "./SalesByStoreTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports